<template>
  <v-timeline align="center">
    <v-timeline-item
      v-for="(item, i) in array1"
      :key="i"
      :dot-color="color"
      size="small"
    >
      <template v-slot:opposite>
        <div
          :class="`pt-1 headline font-weight-bold text-${color}`"
          style="font-size: larger"
          v-text="item.fecha"
        ></div>
      </template>
      <div class="my-timeline-card" align="center">
        <v-card
          class="mx-auto"
          max-width="344"
          hover
          variant="tonal"
          color="light-blue-darken-4"
        >
          <v-card-text class="txtdata custom-bullets">
            <ul>
              <li v-for="(data, i) in item.descripcion" :key="i">{{ data }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </div>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
export default {
  props: {
    array1: {
    type: Array,
    default: () => []
  },
  color: {
    type: String,
    default: ''
  }
  },
};
</script>

<style scoped>
@media (min-width: 1200px) {
  /* Ajusta este valor según el breakpoint que desees */
  .my-timeline-card {
    margin-left: 100px;
    margin-right: 100px;
  }
}

@media (max-width: 1199px) {
  .my-timeline-card {
    margin: 0;
  }
}

.custom-bullets ul {
  list-style-type: none;
  padding-left: 0;
}
.custom-bullets ul li::before {
  content: '★'; /* Carácter personalizado para la viñeta */
  color: #01589F; /* Color de la viñeta */
  padding-right: 5px;
   /* Espacio entre la viñeta y el texto */
}

li{
    padding-bottom: 10px;
}
.txtdata {
  font-family: Arial, Helvetica, sans-serif;
  font-size: large;
  font-weight: 600;
}
</style>
